import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './PermitTypeSelector.css';

const IndyResidentialPermitSelector = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleSelect = (route, permitType) => {
    navigate(route, {
      state: {
        permitType,
        city: location.state?.city,
        county: location.state?.county
      }
    });
  };

  return (
    <div className="permit-type-selector-container">
      <div className="permit-type-selector-card">
        <div className="selector-header">
          <h1>Indianapolis – Class 2 Residential Permits</h1>
          <p>Select the specific residential permit you would like to apply for.</p>
          {location.state?.city && location.state?.county && (
            <p className="location-info">
              Location: <strong>{location.state.city}, {location.state.county}</strong>
            </p>
          )}
        </div>

        <div className="permit-types-grid">
          <div
            className="permit-type-card"
            onClick={() => handleSelect('/submit/indy/residential-development', 'indy_res_dev')}
          >
            <div className="permit-type-icon">DEV</div>
            <div className="permit-type-name">Residential Development / Structural</div>
            <div className="permit-type-description">
              Main development / structural permit for Class 2 residential projects.
            </div>
          </div>

          <div
            className="permit-type-card"
            onClick={() => handleSelect('/submit/indy/residential-hvac', 'indy_res_hvac')}
          >
            <div className="permit-type-icon">HVAC</div>
            <div className="permit-type-name">Heating & Cooling Permit</div>
            <div className="permit-type-description">
              HVAC permits for Class 2 residential projects.
            </div>
          </div>

          <div
            className="permit-type-card"
            onClick={() => handleSelect('/submit/indy/residential-plumbing', 'indy_res_plumbing')}
          >
            <div className="permit-type-icon">PLMB</div>
            <div className="permit-type-name">Plumbing Permit</div>
            <div className="permit-type-description">
              Plumbing permits for Class 2 residential projects.
            </div>
          </div>

          <div
            className="permit-type-card"
            onClick={() => handleSelect('/submit/indy/residential-wrecking', 'indy_res_wrecking')}
          >
            <div className="permit-type-icon">WRCK</div>
            <div className="permit-type-name">Wrecking / Removal Permit</div>
            <div className="permit-type-description">
              Demolition or removal of Class 2 residential structures.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndyResidentialPermitSelector;

